import { useSelector, useDispatch } from "react-redux";

/**
 * Custom hook to centralize all Redux selectors for the Tracker component
 * Reduces repetitive useSelector calls and improves maintainability
 */
export const useTrackerRedux = () => {
  const dispatch = useDispatch();
  const { appSettings } = useSelector((state) => state.appSettings);
  const timerRedux = useSelector((state) => state.timeTrackerLog);
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const timerData = useSelector((state) => state.timerData.timerDataState);
  const timeTrackerLog = useSelector((state) => state.timeTrackerLog);
  const { eventDetails } = useSelector((state) => state.eventDetails);

  return {
    dispatch,
    appSettings,
    timerRedux,
    token,
    user,
    timerData,
    timeTrackerLog,
    eventDetails,
  };
};
